import * as THREE from 'three'
import Experience from "../Experience"

export default class Fish {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        // Debug
        // if (this.debug.active) {
        //     this.debugFolder = this.debug.ui.addFolder('fish')
        // }

        // Setup
        this.resource = this.resources.items.fishModel
        this.setModel()
        // this.setTextures()
        this.setAnimation()
        this.setMaterial()

        // Bind the method to the instance, otherwise the eventlistener uses the DOM element to look for the method which is wrong
        this.switchAnimation = this.switchAnimation.bind(this)

        this.addEventListeners()

    }

    // Check if hotspot is clicked
    addEventListeners() {
        // window.addEventListener('click', (event) => document.querySelectorAll('.point-fish')[0].switchAnimation(), false);
        document.querySelectorAll('.point-fish')[0].addEventListener('click', this.switchAnimation)
        document.querySelectorAll('.point-fish')[0].parentElement.querySelector('.close').addEventListener('click', this.switchAnimation)
    }

    setModel() {

        this.model = this.resource.scene
        this.model.position.set(3.5, -.5, 3.5)
        // Scale and rotation influences the tracked hotspot
        this.model.scale.set(.5, .5, .5)
        // this.model.rotation.set(0, Math.PI * 0.5, 0)
        // this.model.position.set(100, 100, 100)
        this.scene.add(this.model)

        // console.log(this.model)
    }

    setMaterial() {
        this.model = this.resource.scene

        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.material.dispose()
                child.material = new THREE.MeshStandardMaterial({ map: child.material.map, metalness: 0.3, roughness: 0.7 })
                child.receiveShadow = true // Prevents weird shadows on top of boat
                child.castShadow = true

            }
        })

        // console.log(this.model.children[1].children[0].children[0].material)
        // let m = this.model.children[1].children[0].children[0].material
        // if (m) {
        //     m.dispose()
        // }

        // // m.visible = false
        // m = new THREE.MeshStandardMaterial({
        //     color: 0xffffff,
        //     envMap: null,
        //     map: null,
        // })
        // m.needsUpdate = true;
        // console.log(m)


        // m = new THREE.MeshPhongMaterial({
        //     color: 0x446655,
        //     wireframe: false,
        //     //map: mapTex,
        //     onBeforeCompile: shader => {
        //         shader.uniforms.time = m.userData.uniforms.time;
        //         shader.uniforms.totalLength = m.userData.uniforms.totalLength;
        //         shader.vertexShader = `
        //         uniform float time;
        //         uniform float totalLength;
        //         attribute float parts;
        //         varying float vParts;
        //         varying vec4 vPos;
        //         varying vec3 vN;

        //         float getWave(float x){
        //           float currX = mod(x - (time * 4.), 3.1415926535 * 2.);
        //           return sin(currX) * 0.375 * pow((x / totalLength), 2.);
        //         }
        //         float getAngle(float x){
        //           float d = 0.001;
        //           float dz = getWave(x + d) - getWave(x);
        //           return atan( dz, d );
        //         }
        //         // https://gist.github.com/yiwenl/3f804e80d0930e34a0b33359259b556c //
        //         mat4 rotationMatrix(vec3 axis, float angle) {
        //             axis = normalize(axis);
        //             float s = sin(angle);
        //             float c = cos(angle);
        //             float oc = 1.0 - c;

        //             return mat4(oc * axis.x * axis.x + c,           oc * axis.x * axis.y - axis.z * s,  oc * axis.z * axis.x + axis.y * s,  0.0,
        //                         oc * axis.x * axis.y + axis.z * s,  oc * axis.y * axis.y + c,           oc * axis.y * axis.z - axis.x * s,  0.0,
        //                         oc * axis.z * axis.x - axis.y * s,  oc * axis.y * axis.z + axis.x * s,  oc * axis.z * axis.z + c,           0.0,
        //                         0.0,                                0.0,                                0.0,                                1.0);
        //         }

        //         vec3 rotate(vec3 v, vec3 axis, float angle) {
        //           mat4 m = rotationMatrix(axis, angle);
        //           return (m * vec4(v, 1.0)).xyz;
        //         }
        //         /////////////////////////////////////////////////////////////////////
        //         ${shader.vertexShader}
        //       `.replace(
        //             `#include <beginnormal_vertex>`,
        //             `#include <beginnormal_vertex>
        //           float ang = getAngle(position.x);
        //           objectNormal = normalize(rotate(vec3(normal), vec3(0, 1, 0), ang));
        //           vN = objectNormal;
        //         `
        //         )
        //             .replace(
        //                 `#include <begin_vertex>`,
        //                 `#include <begin_vertex>
        //           vParts = parts;
        //           transformed.z += getWave(position.x);
        //           vPos = modelMatrix * vec4(transformed, 1.0);
        //         `
        //             );
        //         // console.log(shader.vertexShader);
        //         shader.fragmentShader = `
        //         uniform float time;
        //         varying float vParts;
        //         varying vec4 vPos;
        //         varying vec3 vN;
        //         ${simpleNoise}
        //         ${shader.fragmentShader}
        //       `.replace(
        //             `vec4 diffuseColor = vec4( diffuse, opacity );`,
        //             `
        //           vec3 col = diffuse;
        //           float parts = floor(vParts + 0.01);
        //           if (parts == 0.){
        //             col = diffuse;
        //             float wave = sin(vUv.y * PI2 * 6.) * 0.5 + 0.5;
        //             col *= wave * 0.15 + 0.2;
        //             col = mix(diffuse, col, smoothstep(0.9, 0.5, abs(vUv.x - 0.5) * 2.));
        //             col = mix(col, diffuse * 0.25, smoothstep(0.2, 0.0, vUv.y));


        //             float head = abs(sin(vUv.x * PI2));
        //             head = head * 0.05 + 0.175;
        //             col = mix(diffuse * 0.25, col, smoothstep(1. - head, 1. - (head + 0.025), vUv.y));

        //             vec2 eyeUv = vUv;
        //             eyeUv.x = abs(vUv.x - 0.5) * 0.35;
        //             float eyeDist = distance(vec2(0.07, 0.875), eyeUv);
        //             float eye = smoothstep(0.02, 0.0175, eyeDist);
        //             col = mix(col, vec3(1, 1, 0) * 0.2, eye);
        //             eye = smoothstep(0.015, 0.0125, eyeDist);
        //             col = mix(col, vec3(0.05), eye);

        //             vec2 mouthUv = vUv;
        //             mouthUv.x = abs(vUv.x - 0.5) * 2.;
        //             mouthUv.x -= mouthUv.y * 0.25;
        //             float mouth = 1. - (cos(mouthUv.x * PI2) * 0.5 + 0.5);
        //             mouth = pow(mouth, 64.) * 0.05 + 0.001;
        //             mouth = 1. - mouth;
        //             col = mix(diffuse * 0.4, col, smoothstep(mouth, mouth - 0.001, mouthUv.y));
        //           }
        //           if (parts == 1.){
        //             col = (vec3(0.375, 0.1, 0.05) * 3.) * diffuse;
        //             float wave = sin(vUv.x * PI2 * 70.) * 0.5 + 0.5;
        //             wave *= sin(vUv.y * PI2 * 5.) * 0.5 + 0.5;
        //             col *= wave * 0.25 + 0.75;
        //             vec2 tailUv = vUv;
        //             tailUv.y -= 0.5;
        //             tailUv.y = abs(tailUv.y) * 2.;
        //             col = mix(diffuse * 0.25, col, smoothstep(1., 0.5, tailUv.y));
        //           }

        //           vec4 diffuseColor = vec4( col, opacity );
        //         `
        //         ).replace(
        //             `#include <dithering_fragment>`,
        //             `#include <dithering_fragment>

        //         // fake caustic
        //         vec2 cPos = vPos.xz - (1, 0.25) * vPos.y;
        //         vec2 cUv = (cPos - vec2(time * 1.5, 0.));

        //         float caustic = abs(smoothNoise(cUv) - 0.5);
        //         caustic = pow(smoothstep(0.5, 0., caustic), 2.);
        //         float causticFade = smoothNoise(cPos - vec2(time, 0.));
        //         caustic *= causticFade;

        //         float causticShade = clamp(dot(normalize(vec3(1, 1, 0.25)), vN), 0., 1.);
        //         caustic *= causticShade;

        //         gl_FragColor.rgb += vec3(caustic) * 0.25;

        //         `
        //         );
        //         // console.log(shader.fragmentShader);
        //     }
        // });
    }
    // setTextures() {
    //     this.textures = {}
    //     this.textures.color = this.resources.items.fishTexture
    //     this.textures.color.colorSpace = THREE.SRGBColorSpace
    //     this.textures.color.repeat.set(1.5, 1.5)
    //     this.textures.color.wrapS = THREE.RepeatWrapping
    //     this.textures.color.wrapT = THREE.RepeatWrapping

    //     this.textures.normal = this.resources.items.grassNormalTexture
    //     this.textures.normal.repeat.set(1.5, 1.5)
    //     this.textures.normal.wrapS = THREE.RepeatWrapping
    //     this.textures.normal.wrapT = THREE.RepeatWrapping
    // }

    setAnimation() {
        this.animation = {}
        this.animation.mixer = new THREE.AnimationMixer(this.model)

        this.animation.actions = {}

        this.animation.actions.path = this.animation.mixer.clipAction(this.resource.animations[0])
        this.animation.actions.swim = this.animation.mixer.clipAction(this.resource.animations[1])
        // this.animation.actions.joel = this.animation.mixer.clipAction(this.resource.animations[2])

        this.animation.actions.current = this.animation.actions.path
        this.animation.actions.current.play()
        this.isAnimating = true
        this.animation.actions.swim.play()

        // console.log(this.resource.animations)
        // if (this.experience.changeAnimation.animate(clicked)) {
        //     this.animation.actions.current = this.animation.actions.rotate
        // }

        // You can fade, crossfade, etc. between the animation (cool)
        // You can test that by using the console, window.experience.world.fox.animation.play('walking')
        // this.animation.play = (name) => {
        //     const newAction = this.animation.actions[name]
        //     const oldAction = this.animation.actions.current

        //     newAction.reset()
        //     newAction.play()
        //     newAction.crossFadeFrom(oldAction, 1)

        //     this.animation.actions.current = newAction
        // }

        // // Debug
        // if (this.debug.active) {
        //     const debugObject = {
        //         playIdle: () => { this.animation.play('idle') },
        //         playWalking: () => { this.animation.play('walking') },
        //         playRunning: () => { this.animation.play('running') }
        //     }

        //     this.debugFolder.add(debugObject, 'playIdle')
        //     this.debugFolder.add(debugObject, 'playWalking')
        //     this.debugFolder.add(debugObject, 'playRunning')
        // }
    }

    // Cycling animations
    // switchAnimation() {
    //     const animations = Object.values(this.animation.actions); // In this case it's 3
    //     const currentActionIndex = animations.indexOf(this.animation.actions.current); // Starts at 0 immediately

    //     // Determine the next action
    //     let nextAction;
    //     console.log(currentActionIndex)

    //     if (currentActionIndex === animations.length - 2) { // Because 0 already starts, we have 1 and 2 left. Except when you click, it already goes to 1. So -2 here.
    //         // If the last animation is reached, go back to the first animation
    //         nextAction = animations[0];

    //     } else {
    //         // Otherwise, go to the next animation in the array
    //         nextAction = animations[currentActionIndex + 1];

    //     }

    //     // Reset and play the next action, with a crossfade from the current action
    //     nextAction.reset();
    //     nextAction.play();
    //     nextAction.crossFadeFrom(this.animation.actions.current, 1);

    //     // Update the current action to the new one
    //     this.animation.actions.current = nextAction;
    // }

    // On/off
    switchAnimation() {
        const currentAction = this.animation.actions.current;
        const duration = 1000; // Duration of the transition in milliseconds
        const startTime = this.time.elapsed;
        const initialRate = currentAction.timeScale; // Capture the current playback rate, should be 1 on the first click

        const updateRate = () => {
            const elapsedTime = this.time.elapsed - startTime;
            const progress = Math.min(elapsedTime / duration, 1);

            if (this.isAnimating) {
                // If the animation is currently running, decrease the rate to 0
                currentAction.timeScale = initialRate - initialRate * progress;

                if (progress >= 1) {
                    currentAction.paused = true; // Pause the animation when fully slowed down
                    this.isAnimating = false; // Toggle state to paused
                    // console.log(this.model.children[1].position)

                }
            } else {
                // If the animation is paused, increase the rate to 1
                currentAction.paused = false; // Immediately unpause
                currentAction.timeScale = initialRate + (1 - initialRate) * progress;

                if (progress >= 1) {
                    this.isAnimating = true; // Toggle state to playing
                }
            }

            if (progress < 1) {
                requestAnimationFrame(updateRate); // Continue updating until the duration completes
            }
        };

        requestAnimationFrame(updateRate);
    }


    update() {
        this.animation.mixer.update(this.time.delta / 1000) // Divide by 1000 because it's in milliseconds
    }
}